class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener(
            "keyup",
            (evt) => evt.code === "Escape" && this.close()
        );
        this.querySelector("#CartDrawer-Overlay").addEventListener(
            "click",
            this.close.bind(this)
        );
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector("#cart-icon-bubble");
        if (!cartLink) return;

        cartLink.setAttribute("role", "button");
        cartLink.setAttribute("aria-haspopup", "dialog");
        cartLink.addEventListener("click", (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener("keydown", (event) => {
            if (event.code.toUpperCase() === "SPACE") {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        // Don't open if already active to prevent issues with multiple calls
        if (this.classList.contains("active")) {
            return;
        }
        
        if (triggeredBy) this.setActiveElement(triggeredBy);
        
        // Always store current scroll position before opening drawer, regardless of how it's called
        this.preservedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
            this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            // Dispatch a custom event to notify other components the drawer is opened
            // This will trigger the drawerOpen event listener in cart-drawer.liquid
            // which already calls updatePackageProtectionStatus
            const drawerOpenEvent = new CustomEvent("drawerOpen", {
                bubbles: true,
                detail: { drawer: "cart-drawer" },
            });
            document.dispatchEvent(drawerOpenEvent);
            this.classList.add("animate", "active");
        });

        this.addEventListener(
            "transitionend",
            () => {
                const containerToTrapFocusOn = this.classList.contains(
                    "is-empty"
                )
                    ? this.querySelector(".drawer__inner-empty")
                    : document.getElementById("CartDrawer");
                const focusElement =
                    this.querySelector(".drawer__inner") ||
                    this.querySelector(".drawer__close");
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        // Always add no-scroll class and preserve scroll position
        document.body.classList.add("no-scroll");
        // Set the top position to lock the current scroll position
        document.body.style.top = `-${this.preservedScrollPosition}px`;
    }

    close() {
        this.classList.remove("active");
        removeTrapFocus(this.activeElement);
        
        // Restore scroll position and remove no-scroll class
        document.body.classList.remove("no-scroll");
        document.body.style.top = '';
        
        // Restore the scroll position if it was preserved
        if (typeof this.preservedScrollPosition !== 'undefined') {
            window.scrollTo(0, this.preservedScrollPosition);
            this.preservedScrollPosition = undefined;
        }

        // Dispatch a custom event to notify other components the drawer is closed
        const drawerCloseEvent = new CustomEvent("drawerClose", {
            bubbles: true,
            detail: { drawer: "cart-drawer" },
        });
        document.dispatchEvent(drawerCloseEvent);
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute("role", "button");
        cartDrawerNote.setAttribute("aria-expanded", "false");

        if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
            cartDrawerNote.setAttribute(
                "aria-controls",
                cartDrawerNote.nextElementSibling.id
            );
        }

        cartDrawerNote.addEventListener("click", (event) => {
            event.currentTarget.setAttribute(
                "aria-expanded",
                !event.currentTarget.closest("details").hasAttribute("open")
            );
        });

        cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    }

    renderContents(parsedState) {
        // console.log("renderContents");
        // console.log({ parsedState });
        // console.log(
        //     `this.querySelector(".drawer__inner").classList.contains("is-empty"): `,
        //     this.querySelector(".drawer__inner").classList.contains("is-empty")
        // );
        this.querySelector(".drawer__inner").classList.contains("is-empty") &&
            this.querySelector(".drawer__inner").classList.remove("is-empty");
        document.querySelector(".drawer").classList.contains("is-empty") &&
            document.querySelector(".drawer").classList.remove("is-empty");
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);

            if (!sectionElement) return;
            sectionElement.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
            );
        });

        setTimeout(() => {
            this.querySelector("#CartDrawer-Overlay").addEventListener(
                "click",
                this.close.bind(this)
            );
            this.open();
        });
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: "cart-drawer",
                selector: "#CartDrawer",
            },
            {
                id: "cart-icon-bubble",
            },
        ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: "CartDrawer",
                section: "cart-drawer",
                selector: ".drawer__inner",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
        ];
    }
}

customElements.define("cart-drawer-items", CartDrawerItems);
